import script from "./CommissionRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionRecords.vue?vue&type=script&setup=true&lang=js"

import "./CommissionRecords.vue?vue&type=style&index=0&id=6b761024&lang=css"

const __exports__ = script;

export default __exports__